module.exports = __webpack_public_path__ + "static/media/websiteIcon.6b90d7dc.svg";